module.exports = __webpack_public_path__ + "static/media/joop.1d147ea5.jpg";